"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _dialog = _interopRequireDefault(require("./dialog"));

var _illustration = _interopRequireDefault(require("../Illustration/illustration"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InfoDialog = function InfoDialog(_ref) {
  var children = _ref.children;
  return _react.default.createElement(_dialog.default, null, _react.default.createElement(_dialog.default.Content, null, _react.default.createElement(_illustration.default, {
    name: "exclamation"
  }), children));
};

InfoDialog.propTypes = {
  /** {---} Sequence of:
    @@<H2>@@ (required, max: 1)
    @@<Paragraph>@@ (optional, max: 1)
    @@<Dialog.Actions>@@ (optional, max: 1)
  */
  children: _propTypes.any.isRequired
};
var _default = InfoDialog;
exports.default = _default;
InfoDialog.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "InfoDialog",
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": "{---} Sequence of:\n    @@<H2>@@ (required, max: 1)\n    @@<Paragraph>@@ (optional, max: 1)\n    @@<Dialog.Actions>@@ (optional, max: 1)"
    }
  }
};